// wrap function on window for easier mocking in tests
export function getRandomValues(array: Uint8Array): Uint8Array {
    return window.crypto.getRandomValues(array) as Uint8Array;
}

